import { Search } from "lucide-react"

interface Props {
  isOpen: boolean
  onClick: () => void
}

// Looks like the desktop search pill, behaves like a button: on phones the
// real input lives inside the full-screen sheet so the keyboard and the
// results never fight over the same 640px.
const MobileSearchTrigger = ({ isOpen, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    aria-haspopup="dialog"
    aria-expanded={isOpen}
    className="flex w-full items-center gap-2 rounded-xl bg-zinc-100 px-3 py-2.5 text-left text-sm text-slate-500 transition-colors active:bg-slate-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400/20"
  >
    <Search size={16} aria-hidden="true" className="shrink-0" />
    <span className="truncate">Search</span>
  </button>
)

export default MobileSearchTrigger
